import { Box, Flex, RichContent, Section, Typography } from 'components';
import { useJourneys } from 'features/journeys';

import styled from 'styled-components';
import AreaDetailsCard from '../areaDetailsCard';

const Degradee = styled(Flex)`
  background: linear-gradient(180deg, transparent 0%, rgba(23, 25, 24, 0.5) 50%, rgba(23, 25, 24, 1) 100%);
`;

const AreaHero = () => {
  const { journeyAreaDetails } = useJourneys();

  return (
    <Degradee flexDirection="column" flexGrow={0}>
      <Section flexGrow={0} alignItems="flex-start" justifyContent={{ d: 'space-between' }} pt={{ m: 6, d: 380 }} pb={{ d: 200 }}>
        <Flex flexGrow={0} flexDirection="column" maxWidth={{ d: 685 }}>
          {!!journeyAreaDetails?.hat && (
            <Typography type="type3" color="gray_500" upper mb={2}>
              {journeyAreaDetails?.hat}
            </Typography>
          )}

          <Typography type="type6" color="white" fontWeight="bold">
            {journeyAreaDetails?.name}
          </Typography>

          {!!journeyAreaDetails?.description && (
            <Box mt={{ m: 3, d: 4 }}>
              <RichContent defaultType="type1" textColor="white">
                {journeyAreaDetails?.description}
              </RichContent>
            </Box>
          )}
        </Flex>

        <Flex flexGrow={0} width={{ m: '100%', d: 370 }} my={{ m: 4, d: 0 }}>
          <AreaDetailsCard area={journeyAreaDetails} internal />
        </Flex>
      </Section>
    </Degradee>
  );
};

export default AreaHero;
